import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import { Model, Opts } from "@ofqual/portal-core/core/types";

export class SeriesService extends BaseRemoteService {
  public async getAll(opts: Opts): Promise<Model[]> {
    const url = `${this.apiRoot}/examseries`;
    const data = await super.getRequest<Model[]>(url, opts);
    return data.map((item) => ({
      id: item.id.toString(),
      label: item.code,
      active: item.active,
    }));
  }
}
